import React, {  useEffect, useState } from 'react'

const SideModal = ({title,children,onShow,setOnShow,saveHandler=()=>{},cancelHandle=()=>{}}) => {
    const [isHidden,setIsHidden] = useState(true);

    const onHide = () => {
        setIsHidden(true);
        setOnShow(false);
        
    }
    
    useEffect(()=>{
        if(onShow && isHidden){
            setIsHidden(false);
        }
    },[onShow,isHidden]);
    
    const ChildrenComponent = (props) => {
        return React.cloneElement(children, props);
    }
    return (
        // <div className={`flex flex-col items-end h-screen w-full bg-gray-700/75 absolute bottom-0 top-0 left-0 right-0 z-50 ${ !isHidden ? 'block' : 'hidden'  } `} >
            // Closed, the panel is 0 wide and has no border: a border kept a 2px line at the page edge.
            <div
                className={` absolute z-[120] end-0 dark:bg-slate-900 bg-gray-300 dark:border-slate-900 border-slate-200 overflow-y-auto transition-all duration-500 ease-out ${ !isHidden ? ' w-11/12 md:w-4/6 border-s-2' : ' w-0 border-0'  } `}
                style={{
                    top: 'var(--header-height, 72px)',
                    height: 'calc(100vh - var(--header-height, 72px))'
                }}
            >
                {/* <div
                    className=' flex items-center justify-between  bg-slate-200  rounded-t  border-b border-slate-400 p-3 text-sm bg-slate-200   sticky top-0'
                    >
                    <div>{title}</div>
                    <AiFillCloseCircle size={24} onClick={onHide} className='hover:text-sky-800' />
                </div> */}
                <div className='h-full bg-slate-100 dark:bg-slate-900'>
                    {!isHidden && <ChildrenComponent onHide={onHide} />}
                </div>
            </div>

        // </div>
    )
}

export default SideModal
